/**
 * Styled Components - Created by gustavomedina on 11/04/18.
 */
import styled from 'styled-components'
import Slider from 'antd/lib/slider'
import AntdButton from 'antd/lib/button'
import { BLACK, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface DivProps {
  secondary?: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${WHITE};
  align-items: center;
`

export const HeadersContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const SideBar = styled.div`
  width: 30%;
  padding-top: 36px;
  padding-right: 32px;
`

export const Title = styled.div`
  color: #5f6062;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  text-transform: uppercase;
  padding-right: 10px;
`

export const AboutTitle = styled.div`
  color: #5f6062;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 30px;
`

export const ErrorTitle = styled.div`
  color: #e21530;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  text-transform: uppercase;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
`

export const AboutContainer = styled.div`
  padding: 30px;
`

export const TierContainer = styled.div`
  padding-top: 40px;
`

export const OrderTitle = styled.div`
  color: #5f6062;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 19px;
  text-align: right;
`

export const Content = styled.div`
  width: 70%;
  padding-top: 36px;
  padding-left: 36px;
`

export const PriceTitle = styled.div`
  padding-top: 27px;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 23px;
`

export const PriceDescription = styled.div`
  padding-top: 10px;
  color: #5f6062;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
`

export const TierTitle = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 23px;
  text-align: center;
`

export const TierDescription = styled.div`
  padding-top: 5px;
  color: #5f6062;
  font-size: 12px;
  letter-spacing: 0.15px;
  line-height: 16px;
  text-align: center;
`

export const Text = styled.div`
  color: #fff;
`

export const StyledSlider = styled(Slider)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
`

export const ButtonWrapper = styled.div`
  margin-bottom: 10px;
  padding-right: 10px;
  .ant-btn-primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
    width: 70px;
  }
  .ant-btn-primary:hover {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }
`

export const Button = styled(AntdButton)`
  height: 40px;
  width: 70px;
`

export const DefaultButton = styled(AntdButton)`
  height: 40px;
`

export const ImageBanner = styled.img`
  height: 30%;
  width: 100%;
  object-fit: cover;
`

export const CalendarView = styled.div`
  height: 78px;
  width: 81px;
  margin-right: 5px;
  margin-left: 5px;
  border: 2px solid #8c8c8c;
  border-radius: 2px;
`

export const CalendarFinalView = styled.div`
  height: 78px;
  width: 81px;
  margin-right: 5px;
  margin-left: 5px;
  border: 2px solid #e61737;
  border-radius: 2px;
`

export const CalendarTitle = styled.div`
  text-align: center;
  width: 100%;
  height: 20px;
  color: #ffffff;
  background-color: #8c8c8c;
  text-transform: uppercase;
`

export const CalendarFinalTitle = styled.div`
  text-align: center;
  width: 100%;
  height: 20px;
  color: #ffffff;
  background-color: #e61737;
  text-transform: uppercase;
`

export const CalendarDay = styled.div`
  text-align: center;
  width: 100%;
  height: 80%;
  font-size: 36px;
  font-weight: bold;
  color: #5f6062;
`

export const DatesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  padding-top: 20px;
  align-items: right;
  justify-content: flex-end;
`

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
`

export const CalendarContainer = styled.div`
  margin-bottom: 20px;
  text-align: center;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const DatesTitle = styled.div`
  color: #5f6062;
  font-size: 12px;
  letter-spacing: 0.15px;
  line-height: 16px;
  padding-bottom: 5px;
`

export const ListContainer = styled.div`
  padding-right: 32px;
  padding-left: 32px;
`

export const AnimatedDiv = styled.div`
  position: fixed;
  bottom: 44px;
  left: 22px;
  z-index: 3;
`

export const BounceDiv = styled.div`
  ${({ secondary }: DivProps) => secondary ? `
  animation: wobble-hor-bottom 0.8s 0s 2 both;
  @keyframes wobble-hor-bottom {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-15px);
    }
    60% {
      transform: translateY(-7px);
      filter: grayscale(0.7);
    }
  }
  ` : ''}
`

export const CartIcon = styled.div`
  background: ${WHITE};
  border-radius: 50%;
  width: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 68px;
  box-shadow: 0px 1px 9px -2px #6e6e6e;
  transition: all .25s;
  .ant-badge-count {
    transform: translateX(30%);
  }
  animation: fade-in-leftDesuZ 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) 1s both;
  @keyframes fade-in-leftDesuZ {
    0% {
      transform: translateX(-30px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  &:hover {
    cursor: pointer;
    filter: opacity(0.7);
  }
  @media (max-width: 698px) {
    width: 48px;
    height: 48px;
  }
`

export const ShoppingCartIcon = styled(Icon)`
  font-size: 32px;
  color: ${BLACK};
  @media (max-width: 698px) {
    font-size: 24px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/StoreFront/styledComponents.tsx